import { getCustodianList } from 'Api/custodians';
import { ModelAccountCustodianItem } from 'Components/Account/models';
import { SET_ALL } from './mutation-types';

let custodianListLoadingPromise = null;
export default {
  async loadCustodianList({ commit }) {
    if (custodianListLoadingPromise) return custodianListLoadingPromise;
    custodianListLoadingPromise = getCustodianList();
    const data = await custodianListLoadingPromise;
    const custodianList = (data?.data || []).map(item => new ModelAccountCustodianItem({ name: item.name, website: item.website }));
    commit(SET_ALL, { custodianList });
    custodianListLoadingPromise = null;
    return custodianList;
  },
};
